<div *ngIf="isUploadStatus !== 'typeCode' && isUploadStatus !== 'invoice'">
  <div *ngIf="isTabExist(0) || isTabExist(1)">
    <div class="row">
      <div class="col-12 text-start">
        <h5>
          {{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.recentUploads' | translate }}
        </h5>
      </div>
    </div>

    <div class="row" *ngIf="isUploadStatus !== 'address'">
      <div class="col-12">
        <mat-tab-group
          *ngIf="isTabExist(0) || isTabExist(1)"
          mat-align-tabs="start"
          [(selectedIndex)]="selectedTabForUploadType"
          (selectedTabChange)="onUploadTabChange($event)"
          #tabGroup>
          <mat-tab *ngIf="isTabExist(0)" label="{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.manual' | translate }}"></mat-tab>
          <mat-tab *ngIf="isTabExist(1)" label="{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.automated' | translate }}"></mat-tab>
        </mat-tab-group>
      </div>
    </div>

    <mat-table [dataSource]="fileUploadDataSource" class="mt-1">
      <ng-container matColumnDef="file_name">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.fileName' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.file_name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="upload_datetime">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.uploadDate' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.upload_datetime | date : 'dd/MMM/yyyy hh:mm aa' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="user_id">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.uploadType' | translate
        }}</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'td-link': element.file_uploadsource === 'MANUAL' }">
          {{ element.file_uploadsource === 'MANUAL' ? element.user_id : 'System' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="added_user_id">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.user' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="td-link">
          {{ element?.user_id }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="file_id">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.file' | translate
        }}</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [ngClass]="{ 'td-link': element.file_uploadsource === 'ADDRESS' }">
          {{ element.file_uploadsource === 'ADDRESS' ? element.file_id : 'System' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="address_status">
        <mat-header-cell *matHeaderCellDef
          >{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.status' | translate }}
          <i
            matTooltip="{{
              'mapping.shipmentUploadStatus.shipmentUploadStatusTable.refresh' | translate
            }}"
            (click)="this.getFileShipmentStatus()"
            class="ps-1 info-icon bi bi-arrow-clockwise"></i>
        </mat-header-cell>
        <mat-cell
          [ngClass]="{
            failed: element.errors_list?.length,
            created: !element.errors_list?.length
          }"
          *matCellDef="let element">
          {{ element.errors_list?.length ? 'Failed' : 'Created' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef
          >{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.status' | translate }}
          <i
            matTooltip="refresh"
            (click)="this.getFileShipmentStatus()"
            class="ps-1 info-icon bi bi-arrow-clockwise"></i>
        </mat-header-cell>
        <mat-cell
          [ngClass]="{
            failed: element.status === 'Failed',
            processed: element.status === 'Processed',
            partial: element.status === 'Partially Processed',
            created: element.status === 'Created'
          }"
          *matCellDef="let element">
          {{ element.status === 'Created' ? 'In Progress' : element.status }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="specifications_id">
        <mat-header-cell *matHeaderCellDef
          >{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.specification' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.specifications_id }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="address_fileInfo">
        <mat-header-cell *matHeaderCellDef>Info</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index">
          <i
            matTooltip="{{ this.expandedRow === index ? 'Less Info' : 'More Info' }}"
            *ngIf="element.errors_list?.length"
            (click)="insertComponent(index, element?.file_id)"
            [ngClass]="{
              failed: element.errors_list?.length,
              'bi-x-circle': this.expandedRow === index,
              'bi-info-circle': this.expandedRow !== index
            }"
            class="info-icon bi"></i>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fileInfo">
        <mat-header-cell *matHeaderCellDef>{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.info' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element; let index = index">
          <i
            matTooltip="{{ this.expandedRow === index ? 'Less Info' : 'More Info' }}"
            *ngIf="element?.status !== 'Processed' && element?.status !== 'Created'"
            (click)="insertComponent(index, element?._id)"
            [ngClass]="{
              failed: element.status === 'Failed',
              partial: element.status === 'Partially Processed',
              'bi-x-circle': this.expandedRow === index,
              'bi-info-circle': this.expandedRow !== index
            }"
            class="info-icon bi"></i>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" #tableRow></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<div *ngIf="isUploadStatus === 'typeCode'">
  <mat-table [dataSource]="fileUploadDataSource" class="mt-2">
    <ng-container matColumnDef="fileName">
      <mat-header-cell *matHeaderCellDef>{{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.fileName' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.fileName }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="uploadDatetime">
      <mat-header-cell *matHeaderCellDef>{{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.uploadDate' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.addedDateTime | date : 'dd/MMM/yyyy hh:mm aa' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="userId">
      <mat-header-cell *matHeaderCellDef>{{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.user' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element" class="td-link">
        {{ element.addedBy }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="typeCode">
      <mat-header-cell *matHeaderCellDef>{{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.documentType' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ getTypeCodeValue(element.typeCode) }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef>{{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.action' | translate
      }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <i
          matTooltip="View"
          (click)="this.viewUploadedCI(element?.content, element?.imageFormat, element?.typeCode)"
          class="icon-mat bi bi-clipboard-fill"></i>

        <i
          matTooltip="Delete"
          *ngIf="motherStatus !== 'Closed'"
          (click)="this.deleteUploadedCI(element?._id, 'typeCode')"
          class="ps-1 icon-mat bi bi-trash"></i>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedTypeCodeColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedTypeCodeColumns" #tableRow></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>

<div *ngIf="isUploadStatus === 'invoice'">
  <div class="row" *ngIf="this.headerInvoice">
    <div class="col-6 small mt-2">
      <p>
        <em>
          <b>{{ this.headerInvoice?.fileName }}</b>
          {{ this.headerInvoice?.addedDateTime | date : 'dd/MMM/yyyy hh:mm aa' }}</em
        >
      </p>
    </div>
  </div>
  <div *ngIf="invoiceForm?.length">
    <small *ngIf="!checkFormGroupArrayValidity()" class="text-danger">
      {{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.lineItemsFieldValidationFail'
          | translate
      }}</small
    ><br />
    <small *ngIf="!isCurrenciesMatched" class="text-danger">
      {{
        'mapping.shipmentUploadStatus.shipmentUploadStatusTable.lineItemsCurrenciesFail' | translate
      }}
    </small>
    <div>
      <label>
        {{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.currencyCode' | translate }}
      </label>
      <select class="form-control mb-2" (change)="setCurrency($event)">
        <option value="">Select Currency</option>
        <option *ngFor="let eachCurrency of currencyCodes" [value]="eachCurrency">
          {{ eachCurrency }}
        </option>
      </select>
    </div>
    <div class="table-container">
      <table mat-table aria-label="uploadedInvoiceDetails" [dataSource]="invoiceForm">
        <ng-container
          *ngFor="let column of displayedInvoiceColumns; let columnIndex = index"
          [matColumnDef]="column">
          <th mat-header-cell class="lineitem-filed" *matHeaderCellDef>{{ column }}</th>
          <td mat-cell *matCellDef="let element; let rowIndex = index">
            <input
              #matInput
              (keyup)="setTotalValue(column)"
              [formControl]="invoiceForm[rowIndex].controls[column]"
              [value]="element[column]"
              [ngStyle]="{
                'border-color': element.controls[column].errors ? 'red' : 'grey'
              }"
              class="form-control"
              matTooltip="{{
                showValidationErrors(invoiceForm[rowIndex].controls[column], column)
              }}" />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedInvoiceColumns"></tr>
        <tr
          mat-row
          *matRowDef="
            let row;
            index as rowIndex;
            columns: displayedInvoiceColumns;
            sticky: true
          "></tr>
      </table>
    </div>
    <div class="row mb-3">
      <small
        >{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.totalQuantity' | translate }}
        {{ totalLineItemQuantity }}</small
      ><br />
      <small
        >{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.totalLineItemValue' | translate
        }}
        {{ totalLineItemValue }}</small
      >
      <br />
      <small
        >{{ 'mapping.shipmentUploadStatus.shipmentUploadStatusTable.totalNetWeight' | translate }}
        {{ totalNetWeight }}</small
      ><br />
      <small
        >{{
          'mapping.shipmentUploadStatus.shipmentUploadStatusTable.totalGrossWeight' | translate
        }}
        {{ totalGrossWeight }}</small
      >
      <mat-dialog-actions align="end">
        <button
          [disabled]="!checkFormGroupArrayValidity()"
          class="primary-btn"
          (click)="saveInvoiceUploadData()">
          Save
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
